/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type BuySharedContentModuleRegular_browseContentModule = {
    readonly description: string | null;
    readonly " $fragmentRefs": FragmentRefs<"SbMobileContentModuleRegular_browseContentModule" | "SbRespContentModuleRegular_browseContentModule">;
    readonly " $refType": "BuySharedContentModuleRegular_browseContentModule";
};
export type BuySharedContentModuleRegular_browseContentModule$data = BuySharedContentModuleRegular_browseContentModule;
export type BuySharedContentModuleRegular_browseContentModule$key = {
    readonly " $data"?: BuySharedContentModuleRegular_browseContentModule$data;
    readonly " $fragmentRefs": FragmentRefs<"BuySharedContentModuleRegular_browseContentModule">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "BuySharedContentModuleRegular_browseContentModule",
  "type": "ContentModuleRegular",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "description",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbMobileContentModuleRegular_browseContentModule",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespContentModuleRegular_browseContentModule",
      "args": null
    }
  ]
};
(node as any).hash = '9436ea68954aec14a15233ce3475e8b5';
export default node;
